/* 司馬懿傳・第 1 章：新城・八日奔襲（太和元年～二年，227–228）
 * 史實：《晉書·宣帝紀》「達於是連吳固蜀，潛圖中國。……帝恐達速發，以書喻之……達得書大喜，猶與不決。帝乃潛軍進討。
 *       諸將言達與二賊交構，宜觀望而後動。帝曰：『達無信義，此其相疑之時也，當及其未定促決之。』乃倍道兼行，八日到其城下。
 *       吳蜀各遣其將向西城安橋、木闌塞以救達，帝分諸將以距之。」
 *       孟達與諸葛亮書：「宛去洛八百里，去吾一千二百里……則吾所在深險，司馬公必不自來」；兵到後：「吾舉事八日，而兵至城下，何其神速也！」
 *       「上庸城三面阻水，達於城外為木柵以自固。帝渡水，破其柵，直造城下。八道攻之，旬有六日，達甥鄧賢、將李輔等開門出降。斬達，傳首京師。」
 *       《三國志·明帝紀》太和二年「春正月，宣王攻破新城，斬達，傳其首」；注引《魏略》「宣王誘達將李輔及達甥鄧賢，賢等開門內軍。達被圍旬有六日而敗」。
 * 流程（「快」）：在宛的帥帳先寫信穩住孟達（可以不寫，省時間但孟達築城快一倍）→ 倍道兼行一千二百里：天數一直在走，孟達的城一天天加固，
 *       城固滿了就輸；路上孟達的斥候看到大軍會掉頭回報（追上去殺掉）；兩條岔路各分一隊兵去擋吳、蜀的援軍 →
 *       到上庸：箭雨的空檔裡破木柵 → 八道攻之：繞城八面各立一道攻城的兵，城中士氣耗盡，鄧賢、李輔開門 → 斬孟達。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, boss } from '../kit.ts';
import { MEN, TR, days, flag } from './simayi_kit.ts';
import { CITY, WAN, GATE, FENCE_X, FENCE, FORKS } from '../maps/simayi_xincheng.ts';

const LV = 12, DAY = 6, SIEGE_DAY = 3.5;
const DESK = [WAN[0] - 120, WAN[1] - 260], BREACH = [FENCE_X + 260, CITY.y];
const MENG = { spec: TR.meng, name: '孟達兵', hp: 520, maxHp: 520, atk: 26 };
// 八道：繞城八面的攻城位置（北、西、南隔著城牆與堵水之間的一條陸地）
const ROADS8 = [[1500, 1640], [2300, 1640], [2700, 1950], [2700, 2650], [2300, 2960], [1500, 2960], [1120, 2050], [1120, 2550]];

export default {
  id: 'simayi-1', map: 'simayi_xincheng', hero: 'simayi',
  title: '第 1 章　新城・八日奔襲', year: '太和元年（227）～二年（228）',
  brief: {
    quote: [{ text: '乃倍道兼行，八日到其城下。', src: '《晉書·宣帝紀》' }, { text: '吾舉事八日，而兵至城下，何其神速也！', src: '孟達與諸葛亮書，《晉書·宣帝紀》' }],
    text: '新城太守孟達原是蜀將，降魏後又暗中連結吳、蜀。諸葛亮故意讓他的密謀洩露，逼他起事。孟達算定：宛到上庸一千二百里，司馬懿要先上表、等洛陽回覆，一個月後才到得了。司馬懿屯在宛，決定不等。',
    goals: ['（可選）在帥帳寫信穩住孟達', '倍道兼行到上庸：孟達的城加固完就來不及了', '在岔路分兵擋住吳、蜀援軍', '破木柵，八道攻城，斬孟達'],
  },
  words: { ally: '魏軍', foe: '孟達兵' },
  stars: [
    { text: '八日之內到上庸城下', ok: (m) => m.vars.arriveD != null && m.vars.arriveD <= 8 },
    { text: '兩條岔路都分兵擋住援軍', ok: (m) => m.vars.blocked === 2 },
    { text: '圍城旬有六日之內城破', ok: (m) => m.vars.siegeD != null && m.vars.siegeD <= 16 },
  ],
  steps: [
    { // 0. 宛：作書、出發
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        me.x = WAN[0] - 260; me.y = WAN[1] + 120;
        V.t0 = w.t; V.fort = 0; V.blocked = 0; V.forks = {};
        w.addBuff(me, { id: '倍道', t: 9999, ms: 0.2 });
        V.men = Array.from({ length: 10 }, (_, i) => { const u = m.recruit(me.x + 60 + (i % 5) * 45, me.y + 80 + Math.floor(i / 5) * 70, '魏兵'); u.spec = TR.wei; u.hp = u.maxHp = 600; u.atk = 24; m.join(u, me); return u; });
        m.folk(DESK[0], DESK[1], { name: '書案', still: true, near: 1, draw: (ctx, f, T) => flag(ctx, f, T), text: '書' });
        m.mark('desk', DESK[0], DESK[1], '作書', true);
        // 木柵：上庸東面的一道柵欄（三面是水）
        FENCE.forEach(([x, y], k) => m.gate('fence' + k, x, y, 190, 'abatis'));
        // 孟達的斥候：在半路巡邏，看到大軍就掉頭回報
        V.scouts = [[7300, 2260], [5900, 2370]].map(([x, y]) => { const u = m.foe('huangjin', x, y, Object.assign({}, MENG, { name: '孟達斥候', hp: 380, maxHp: 380, ms: 180 })); m.patrol(u, [[x - 300, y], [x + 300, y]]); return u; });
        m.line('司馬懿', '孟達反覆之人，此其相疑之時也——當及其未定促決之！');
        m.after(3, () => m.line('提示', '天數一直在走，孟達的城一天天加固。可以先在帥帳旁寫信穩住他（站著不動 2 秒），他就會猶豫不決、築城慢一半。'));
        m.obj('go', '倍道兼行，到上庸城下');
        m.obj('fork', '在岔路分兵擋住援軍', 2);
        m.mark('city', FENCE_X + 400, CITY.y, '上庸');
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars, d = days(m, w, DAY);
        if (!V.letter && !V.gone) m.chanAt(me, 'desk', DESK[0], DESK[1], 140, 2, '作書喻達', () => {
          V.letter = true; m.unmark('desk');
          m.card('將軍昔棄劉備，託身國家……諸葛亮欲相破，惟苦無路耳。', '司馬懿與孟達書，《晉書·宣帝紀》');
          m.after(2, () => m.line('孟達', '（得書大喜）……司馬公信我。再看看吧。'));
        });
        if (me.x < WAN[0] - 900 && !V.gone) { V.gone = true; m.unmark('desk'); }
        // 孟達築城：得書猶豫不決就慢一半
        V.fort = Math.min(100, V.fort + (dt / DAY) * (V.letter ? 100 / 24 : 100 / 10));
        m.get('go').text = `倍道兼行，到上庸城下（第 ${Math.floor(d) + 1} 日・孟達城固 ${Math.floor(V.fort)}%）`;
        if (V.fort >= 100) { m.lose('孟達的城已經加固，「諸軍足辦」——來得太遲了'); return false; }
        // 斥候：看到司馬懿就跑回上庸報信
        for (const u of V.scouts) {
          if (!u.alive || u.told) continue;
          if (!u.flee && SG.gd(u.x, u.y, me.x, me.y) < 420) { u.flee = true; u.patrol = null; u.home = [FENCE_X + 260, CITY.y]; u.ms = 190; m.line('孟達斥候', '魏軍！快回去報信！'); }
          if (u.flee) { u.target = null; u.think = 0.5; u.home = [FENCE_X + 260, CITY.y]; }
          if (u.flee && u.x < FENCE_X + 500) { u.told = true; u.alive = false; u.counted = true; V.fort = Math.min(99, V.fort + 20); V.warned = true; m.line('孟達', '司馬懿來了？這麼快！快加固木柵！'); }
        }
        // 岔路：在路口站一下，分一隊兵上去擋援軍
        for (const F of FORKS) {
          if (V.forks[F.id]) continue;
          m.chanAt(me, F.id, F.at[0], F.at[1], 200, 1.5, '分兵', () => {
            const left = m.alive(V.men).filter((u) => u.owner === me).slice(0, 3);
            if (!left.length) { m.line('司馬懿', '……沒有兵可分了。'); return; }
            V.forks[F.id] = true; V.blocked++; m.prog('fork', V.blocked); m.unmark(F.id);
            for (const u of left) { u.owner = null; u.home = [F.to[0] + (SG.rand() - 0.5) * 160, F.to[1] + (F.to[1] < CITY.y ? 120 : -120)]; }
            m.line('司馬懿', `分兵往${F.name}，擋住${F.who}軍！`);
          });
          if (!V['seen' + F.id] && me.x < F.at[0] + 900) { V['seen' + F.id] = true; m.mark(F.id, F.at[0], F.at[1], `分兵往${F.name}`, true); }
        }
        if (me.x > FENCE_X + 700) return false;
        V.arriveD = Math.floor(d) + 1;
        return true;
      },
    },
    { // 1. 兵到城下：破柵
      enter(m, w) {
        const me = w.player, V = m.vars;
        m.done('go'); m.unmark('city'); for (const F of FORKS) m.unmark(F.id);
        if (V.arriveD <= 8) m.card('吾舉事八日，而兵至城下，何其神速也！', '孟達與諸葛亮書，《晉書·宣帝紀》');
        else m.line('孟達', '司馬懿來了……幸好木柵已經立起來了。');
        if (V.blocked === 2) m.after(4, () => m.card('吳蜀各遣其將向西城安橋、木闌塞以救達，帝分諸將以距之。', '《晉書·宣帝紀》'));
        // 沒擋住的那一路：援軍趕到
        for (const F of FORKS) if (!V.forks[F.id]) {
          m.after(10, () => {
            m.big(`${F.who}軍來救孟達了！`);
            for (let i = 0; i < 5; i++) { const u = m.foe('huangjin', F.at[0] + 200 + (i % 3) * 60, F.at[1] + (i - 2) * 70, { spec: F.who === '蜀' ? TR.shu : TR.wu, name: F.who + '兵', hp: 560, maxHp: 560, atk: 28 }); u.home = [BREACH[0] + 150, BREACH[1]]; }
          });
        }
        // 柵後的守兵：城越固，人越多
        const n = 4 + Math.floor(V.fort / 15);
        V.def = Array.from({ length: n }, (_, i) => m.foe('huangjin', FENCE_X - 220 - (i % 3) * 80, CITY.y - 300 + (i % 5) * 150, MENG));
        V.volleyT = 2;
        m.line('司馬懿', '木柵擋路——趁箭雨的空檔，拆開中間那一段！');
        m.after(3, () => m.line('提示', '柵後會射箭（地上的紅圈）。等一波箭落下，再站到柵前不動 1.8 秒拆柵；挨了箭就會中斷。'));
        m.mark('breach', BREACH[0], BREACH[1], '破柵');
        m.obj('fence', '破開木柵');
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars;
        // 柵後的弓弩：每 3 秒一波，落在司馬懿腳下
        if (SG.gd(me.x, me.y, BREACH[0], BREACH[1]) < 700 && (V.volleyT -= dt) <= 0) { V.volleyT = 3; m.strike(me.x, me.y, 100, 1, 50 + V.fort, 0); }
        m.chanAt(me, 'breach', BREACH[0], BREACH[1], 150, 1.8, '破柵', () => { V.broke = true; });
        return !!V.broke;
      },
    },
    { // 2. 八道攻之
      enter(m, w) {
        const V = m.vars;
        m.done('fence'); m.unmark('breach');
        FENCE.forEach((_, k) => m.ungate('fence' + k));
        m.gate('gate', GATE[0], GATE[1], 160, 'citygate');
        m.card('帝渡水，破其柵，直造城下。', '《晉書·宣帝紀》');
        V.siege0 = w.t; V.morale = 100; V.roads = ROADS8.map(() => false); V.arrowT = 2;
        V.pts = ROADS8.map(([x, y]) => SG.MAP.nearestFree(x, y));
        V.pts.forEach(([x, y], k) => m.mark('r' + k, x, y, '攻', true));
        m.line('司馬懿', '八道並進，晝夜不息！');
        m.after(3, () => m.line('提示', '繞著上庸走一圈，在八個「攻」的位置各站 1.2 秒，派一道兵攻城。攻城的道越多，城中士氣掉得越快。'));
        m.obj('roads', '八道攻之', 8);
        m.obj('morale', '');
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars, n = V.roads.filter(Boolean).length;
        V.pts.forEach(([x, y], k) => {
          if (V.roads[k]) return;
          m.chanAt(me, 'r' + k, x, y, 130, 1.2, '督攻', () => { V.roads[k] = true; m.unmark('r' + k); m.folk(x, y, { name: '攻城', still: true, near: 1, draw: flag, text: '攻' }); });
        });
        m.prog('roads', n);
        // 城上的箭：靠近城牆的人挨射
        if (Math.abs(me.x - CITY.x) < CITY.hw + 420 && Math.abs(me.y - CITY.y) < CITY.hh + 380 && (V.arrowT -= dt) <= 0) { V.arrowT = 2.6; m.strike(me.x, me.y, 90, 1, 45, 0); }
        V.morale = Math.max(0, V.morale - dt * n * 0.5);
        const d = (w.t - V.siege0) / SIEGE_DAY;
        m.get('morale').text = `城中士氣 ${Math.ceil(V.morale)}%（圍城第 ${Math.floor(d) + 1} 日）`;
        if (V.morale > 0) return false;
        V.siegeD = Math.floor(d) + 1;
        return true;
      },
    },
    { // 3. 鄧賢、李輔開門：斬孟達
      enter(m, w) {
        const V = m.vars;
        m.done('roads'); m.done('morale');
        m.card('宣王誘達將李輔及達甥鄧賢，賢等開門內軍。', '《魏略》（裴注《明帝紀》）');
        m.ungate('gate');
        V.da = boss(w, MEN.mengda, CITY.x + 200, CITY.y, { name: '孟達', hp: 4200, atk: 44, armor: 8, ms: 240 });
        V.da.home = [GATE[0] + 300, GATE[1]];
        for (let i = 0; i < 4; i++) { const u = m.foe('huangjin', CITY.x + 100, CITY.y - 150 + i * 100, MENG); u.home = [GATE[0] + 250, GATE[1]]; }
        m.line('孟達', '鄧賢！李輔！你們……！');
        m.mark('da', V.da.x, V.da.y, '孟達', false, V.da);
        m.obj('da', '斬孟達');
      },
      tick(m, w) {
        const V = m.vars;
        if (V.da.alive) return false;
        m.done('da'); m.unmark('da');
        m.card('斬達，傳首京師。俘獲萬餘人，振旅還于宛。', '《晉書·宣帝紀》');
        m.after(4, () => m.win());
        return true;
      },
    },
    { tick() { return false; } },
  ],
  always(m, w) { if (!w.player.alive) m.lose('司馬懿陣亡'); },
};
